import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AgencyTypes } from 'src/app/Model/Enums/AgencyType.enums';
import { ConnectionTypes } from 'src/app/Model/Enums/ConnectionType.enums';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

interface Conexion {
  Id: string;
  Name: string;
  Type: string;
}

interface GrupoConexion {
  name: string;
  conexion: Conexion[];
}

@Component({
  selector: 'app-agency-nueva',
  templateUrl: './agency-nueva.component.html',
  styleUrls: ['./agency-nueva.component.css']
})
export class AgencyNuevaComponent implements OnInit {
  public formGroup: FormGroup;
  public parrafone;
  public parrafotwo;
  public parrafothree;
  public parrafofour;
  public showBanner:boolean;
  SelectedDescription: string;
  public conexionGroups: GrupoConexion[];
  constructor(formBuilder: FormBuilder, private readonly lsService : SessionStorageService, private readonly translate: TranslateService) {
      this.formGroup = formBuilder.group({
        'SelectedDescription' : ['', Validators.required]
      });
    }

  async ngOnInit(): Promise<void> {

    this.showBanner = environment.showBanner == "true" ? true : false
    this.conexionGroups = [
      {
        name: 'AgenciaNueva.Titles.IATAAgenciesHead',
        conexion: [
          {Id: ConnectionTypes.GDSActivation, Name: 'AgenciaNueva.Titles.BSP', Type:''},
          {Id: ConnectionTypes.GDSReactivation, Name: 'AgenciaNueva.Titles.10', Type:''},
          {Id: ConnectionTypes.AvSync, Name: 'AgenciaNueva.Titles.Sync', Type:'AgenciaNueva.Titles.IATAAgencies'},
          // {Id: ConnectionTypes.AgenciesB2T, Name: 'AgenciaNueva.Titles.AgenciesPortal', Type:'AgenciaNueva.Titles.IATAAgencies'},
          {Id: ConnectionTypes.NDC, Name: 'AgenciaNueva.Titles.AgenciesPortalNDC', Type:'AgenciaNueva.Titles.IATAAgencies'},
          {Id: ConnectionTypes.CreateUsers, Name: 'AgenciaNueva.Titles.CreateSuperUserAndAdminPortal', Type:'AgenciaNueva.Titles.IATAAgencies'},
          {Id: ConnectionTypes.ChangeSuperUser, Name: 'AgenciaNueva.Titles.ChangeSuperUserAndAdminPortal', Type:'AgenciaNueva.Titles.IATAAgencies'},
        ],
      },
      {
        name: 'AgenciaNueva.Titles.NonIATAAgenciesHead',
        conexion: [
          {Id: ConnectionTypes.NoIata, Name: 'AgenciaNueva.Titles.AgenciesPortal', Type:'AgenciaNueva.Titles.NonIATAAgencies'}
        ],
      },
    ];
    if(this.formGroup.invalid == true){
      document.getElementById('e').style.backgroundColor = '#969696'
      document.getElementById('e').style.color = '#FFFFFF'
    }

    if (this.lsService.getLSItem("redirectPACO") != undefined) {
      this.SendToPaco()
    }
  }
  selectedagency(type){
    if(this.formGroup.invalid == false){
      document.getElementById('e').style.backgroundColor = 'red'
    }
    if(type.value.Id == ConnectionTypes.AvSync){
      this.parrafotwo = true
    }else{
      this.parrafotwo = false
    }
    if(type.value.Id == ConnectionTypes.AgenciesB2T || type.value.Id == ConnectionTypes.NoIata || type.value.Id == ConnectionTypes.NDC){
      this.parrafone = true
    }else{
      this.parrafone = false
    }
    if(type.value.Id == ConnectionTypes.GDSActivation){
      this.parrafothree = true
    }else{
      this.parrafothree = false
    }
    if(type.value.Id == ConnectionTypes.GDSReactivation){
      this.parrafofour = true
    }else{
      this.parrafofour = false
    }

    if(type.value.Id == ConnectionTypes.GDSReactivation || type.value.Id == ConnectionTypes.CreateUsers || type.value.Id == ConnectionTypes.ChangeSuperUser){
      this.lsService.setLSItem("type", ConnectionTypes.GDSActivation)
    }
    else if(type.value.Id == ConnectionTypes.NDC){
      this.lsService.setLSItem("type", ConnectionTypes.GDSReactivation)
    }
    else{
      this.lsService.setLSItem("type", type.value.Id)
    }
    switch(type.value.Id)
    {
      case "1":
        this.lsService.setLSItem("agencyType", AgencyTypes.IATA.toString())
      break;
      case "2":
        this.lsService.setLSItem("agencyType", AgencyTypes.NoIATA.toString())
      break;
      case "3":
        this.lsService.setLSItem("agencyType", AgencyTypes.IATA.toString())
      break;
      case "4":
        this.lsService.setLSItem("agencyType", AgencyTypes.IATA.toString())
      break;
      case "5":
        this.lsService.setLSItem("agencyType", AgencyTypes.ReactivateIATA.toString())
        break;
      case "6":
        this.lsService.setLSItem("agencyType", AgencyTypes.IATA.toString())
      break;
      case "7":
        this.lsService.setLSItem("agencyType", AgencyTypes.IATAprimerIngreso.toString())
      break;
      case "8":
        this.lsService.setLSItem("agencyType", AgencyTypes.CambioRepresentanteYAdmin.toString())
      break;
    }
  }

  async newheader(evt){
    let type = this.lsService.getLSItem("type")
    if(type == ConnectionTypes.AvSync || 
      type == ConnectionTypes.AgenciesB2T || 
      (type == ConnectionTypes.GDSReactivation && this.lsService.getLSItem("agencyType") == AgencyTypes.IATA.toString())){
      
      await Swal.fire({
        text: this.translate.instant("Home.Message.Text"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: this.translate.instant("Home.Message.Reject"),
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.translate.instant("Home.Message.Confirm"),
      }).then(result => {
        if(result.isConfirmed){
          this.SendToPaco()
        }
        else{
          this.lsService.setLSItem("type", ConnectionTypes.GDSActivation)
          this.lsService.setLSItem("agencyType", AgencyTypes.IATAprimerIngreso.toString())
          const url = "Register/Main/Request";
          window.location.href = url;
        }
      })
    }
    else{
      let url = evt + "?type=" + type
      window.location.href = url;
    }
  }

  public SendToPaco() {
    this.lsService.removeLSItem('redirectPACO');
    window.location.replace(`Register`);
    let tradeUrl = environment.request.paco + "lang=" + this.lsService.getLSItem('language');

    window.location.assign(tradeUrl);
    window.location.href = tradeUrl;
  }
}
